import { useLocation, useNavigate } from "react-router-dom";

//UTILS
import { PATH_APP } from "../../routes/paths";
import useScreenSize from "../../hooks/useScreenSize";

//STYLES
import styles from "./PageHeader.module.scss";

//STORE
import { useAppDispatch } from "../../store/hooks";
import { openOperationModal } from "../../store/slices/operationDataSlice";

//UI COMPONENTS
import Button from "../Button/Button";

//ASSETS
import StarIcon from "../../assets/icons/star-icon.svg?react";
import MarketIcon from "../../assets/icons/marker-icon.svg?react";
import { openFavoriteModal } from "../../store/slices/marketSlice";
import { useOperationTime } from "../../hooks/useOperationTime";
import useFeatures from "../../hooks/useFeatures";

const PageHeader = () => {
  const { headerContainer, buttonsContainer } = styles;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { pathname } = useLocation();

  const { isMobile } = useScreenSize();

  const { isEnabledOperation } = useOperationTime({
    symbolType: "FUNDS",
  });

  const { isOperateEnabled: isOperateGloballyEnabled } = useFeatures();

  const data = {
    [PATH_APP.valuation]: {
      title: "Valuación de cartera",
      mainDescription: "Conocé su composición y cotizala según tipo de cambio.",
    },
    [PATH_APP.returns]: {
      title: "Evolución de cartera",
      mainDescription:
        "Visualizá la evolución y rendimiento de tus instrumentos.",
      smallDescription: "",
    },
    [PATH_APP.reports]: {
      title: "Informes de cartera",
      mainDescription:
        "Llevá la cuenta de tu tenencia, rendimiento e impuestos.",
      smallDescription: "",
    },
    [PATH_APP.activity]: {
      title: "Actividad",
      mainDescription: "Consultá todas tus órdenes y movimientos.",
      smallDescription: "",
    },
    [PATH_APP.market]: {
      title: "Mercado",
      mainDescription:
        "Conocé las cotizaciones y operá los distintos instrumentos.",
      smallDescription: "",
      buttonText: "Operar",
      buttonDisabled: !isOperateGloballyEnabled || !isEnabledOperation,
      buttonAction: () => dispatch(openOperationModal()),
      secondaryButton: "Favoritos",
      secondaryButtonIcon: <StarIcon />,
      secondaryButtonAction: () => navigate(PATH_APP.favorites),
    },
    [PATH_APP.research]: {
      title: "Research",
      mainDescription: "Mantenete al día con nuestros informes.",
      smallDescription: "",
    },
    [PATH_APP.help]: {
      title: "Preguntas frecuentes",
      mainDescription:
        "Resolvé tus dudas consultando las preguntas más comunes.",
      smallDescription: "",
    },
    [PATH_APP.favorites]: {
      title: "Favoritos",
      mainDescription: "Seguí tus instrumentos de interés.",
      smallDescription: "",
      buttonText: "Agregar favoritos",
      buttonAction: () => dispatch(openFavoriteModal()),
      secondaryButton: "Mercado",
      secondaryButtonIcon: <MarketIcon />,
      secondaryButtonAction: () => navigate(PATH_APP.market),
    },
  };

  if (isMobile || !data?.[pathname]) return null;

  const currentPage = data[pathname];

  return (
    <div className={headerContainer}>
      <div>
        <h1>{currentPage.title}</h1>
        <p>{currentPage.mainDescription}</p>
        {currentPage.smallDescription && (
          <span>{currentPage.smallDescription}</span>
        )}
      </div>

      {(currentPage.buttonText || currentPage.secondaryButton) && (
        <div className={buttonsContainer}>
          {currentPage.secondaryButton && (
            <Button
              variant="secondary"
              text={
                <>
                  {currentPage.secondaryButtonIcon}{" "}
                  {currentPage.secondaryButton}
                </>
              }
              onPress={currentPage.secondaryButtonAction}
            />
          )}
          {currentPage.buttonText && (
            <Button
              text={currentPage.buttonText}
              onPress={currentPage.buttonAction}
              isDisabled={currentPage.buttonDisabled}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
